import React from 'react';
import { Typography } from "../../../components/Typography/Typography";
import { useTranslation } from "../../../hooks/useTranslation";
import { AppDrill } from "../../../icons/index";
import { makeStyles } from "../../../styles/index";
var useStyles = makeStyles(function (theme) { return ({
    // 各種数値は、既存ドリル側の「レベルアップドリルに遷移するボタン」の実装に合うように調整している
    container: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        left: 0,
        height: 56,
        color: theme.palette.common.white,
        backgroundColor: theme.palette.apps.drill,
        '& > svg': {
            position: 'absolute',
            bottom: 0,
            left: -3,
            border: "11px solid " + theme.palette.apps.drill,
            borderRadius: '50%',
            color: theme.palette.apps.drill,
            backgroundColor: theme.palette.common.white,
            padding: 5,
            width: 80,
            height: 80,
        },
    },
    caption: {
        position: 'absolute',
        bottom: 18,
        right: 48,
    },
}); }, { name: 'SnTransitionDrillButton' });
/**
 * スマイルドリル(ベーシックドリル)のコース一覧に遷移するボタン
 */
export var TransitionDrillButton = function () {
    var classes = useStyles();
    var t = useTranslation().t;
    return (React.createElement("a", { href: "/app/drill/drill.html" },
        React.createElement("div", { className: classes.container },
            React.createElement(AppDrill, null),
            React.createElement(Typography, { bold: true, className: classes.caption, variant: "body2" }, t('スマイルドリル')))));
};
